import type React from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../components/FormElements/TextInput'

export const PasswordStep: React.FC = () => {
  const { watch } = useFormContext()
  const password = watch('password')

  return (
    <div className="flex flex-col gap-3">
      <TextInput
        name="password"
        label="Password"
        type="password"
        required
        rules={{
          minLength: {
            value: 8,
            message: 'Password must be at least 8 characters',
          },
        }}
      />
      <TextInput
        name="confirmPassword"
        label="Confirm Password"
        type="password"
        required
        rules={{
          validate: {
            matchPassword: (value: string) => {
              return value === password || 'Passwords do not match'
            },
          },
        }}
      />
    </div>
  )
}
